import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import { toRoman } from 'helpers'
import { helpers } from 'react-wot-bootstrap'
import { TOOLTIPS } from '../../constants'

import VehicleType from 'components/VehicleType/VehicleType'

import styles from './Vehicle.scss'

const Vehicle = (props) => {
    if (!props.vehicle) {
        const className = classNames(styles.base, styles.base__empty)
        return (
            <div className={className} data-tip data-for={TOOLTIPS.NO_VEHICLE.id}/>
        )
    }

    const { nation, name, level, type } = props.vehicle

    const imageClassName = styles.image
    const nationClassName = classNames(styles.nation, styles[`nation__${nation}`])

    const className = classNames(styles.base, {
        [styles.base__cn]: helpers.isChineseRealm(props.realm),
    })

    const iconStyle = {
        backgroundImage: `url(${props.vehicle.icon_url})`,
    }

    return (
        <div className={className}>
            <span className={styles.level}>
                {toRoman(level)}
                <span className={styles.levelGradient}>{toRoman(level)}</span>
            </span>
            <span className={nationClassName} />
            <span className={styles.type}>
                <VehicleType mini type={type} />
            </span>
            <div className={imageClassName} style={iconStyle}/>
            <span className={styles.name}>{name}</span>
        </div>
    )
}

Vehicle.propTypes = {
    vehicle: PropTypes.shape({
        level: PropTypes.number,
        type: PropTypes.string,
        name: PropTypes.string,
        nation: PropTypes.string,
        icon_url: PropTypes.string,
    }),
    realm: PropTypes.string.isRequired,
}

export default Vehicle



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/Squad/components/Vehicle/Vehicle.jsx